import { Location } from '@amzn/red-velvet-api';

/**
 * Display lines for a physical location's address, as the event detail page shows them:
 * the street, then "city, province postal_code". Falls back to the single geocoded
 * address_string only when neither street nor city is set.
 */
export function getLocationAddressLines(location: Location | undefined): string[] {
  if (!location) return [];
  if (!location.street && !location.city) {
    return location.address_string ? [location.address_string] : [];
  }
  const lines: string[] = [];
  if (location.street) lines.push(location.street);
  if (location.city) {
    const region = [location.province, location.postal_code].filter(Boolean).join(' ');
    lines.push(region ? `${location.city}, ${region}` : location.city);
  }
  return lines;
}
